<main class="container-fluid module-container">

  <div class="content-container"  *ngIf="helperService.user.isIncadea !== '1'; else incadea">
    <div class="card-body">
      <div>
        <div class="loading-containerReports" *ngIf="loading">
          <section>
            <div  class="pulsing">
              <mat-spinner [diameter]="50" ></mat-spinner>
            </div>
            <p class="pulsing">{{"Loading" | translate}}</p>
          </section>
        </div>
      </div>
        <mat-form-field class="card-body-reports">
          <mat-label class="filters-label"> *{{ "Information" | translate }}</mat-label>
          <mat-select [(ngModel)]="reportId"  >
            <mat-option
              *ngFor="let reportType of reportsList | async"
              (click)="getNameCity(reportType.reportName)"
              [value]="reportType.reportId"
              >
              {{reportType.reportName | translate}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <!-- Filters -->
        <div class="card-body-components"  [ngClass]="isDisabled ? 'disappear' : undefined">
            <div class="card-body-tittle" *ngIf="roleId === 2 || roleId === 6 || roleId === 1"><strong>{{ "City" | translate }}:</strong>
              <label>{{dataFilterAdvisor.cityName}}</label>
            </div>

            <div class="card-body-tittle" *ngIf="roleId === 2 || roleId === 6 || roleId === 1"><strong>{{ "Workshop" | translate }}:</strong>
              <label>{{dataFilterAdvisor.workshopName}}</label>
            </div>
            <mat-form-field class="card-body-dropdown" *ngIf="roleId === 3 || roleId === 4 || roleId === 5"
            >
                <mat-label class="filters-label">{{ "City" | translate }}*</mat-label>
                <mat-select [disabled]="disableCity" [(ngModel)]="cityId" >
                  <mat-option
                    *ngFor="let dataCity of dataCities"
                    (click)="getWorkshop(dataCity.cityId)"
                    [value]="dataCity.cityId">
                    {{dataCity.cityName}}
                  </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="card-body-dropdown" *ngIf="roleId === 3 || roleId === 4 || roleId === 5">
                <mat-label class="filters-label">{{ "Workshop" | translate }}*</mat-label>
                <mat-select
                [(ngModel)]="workshopId"
                [disabled]="disableWorkshop"
                >
                  <mat-option
                    *ngFor="let dataWorkshop of dataWorkshop"
                    (click)="getAdvisor(dataWorkshop.workshopId)"
                    [value]="dataWorkshop.workshopId"
                    >
                    {{dataWorkshop.workshopName}}
                  </mat-option>
                </mat-select>
            </mat-form-field>
            <div class="card-body-tittle" *ngIf="roleId === 1"><strong>{{ "Advisor" | translate }}:</strong>
              <label>{{dataFilterAdvisor.advisorFullName}}</label>
            </div>
            <mat-form-field class="card-body-dropdown" *ngIf="roleId !== 1">
                <mat-label class="filters-label" >{{ "Advisor" | translate }}*</mat-label>
                <mat-select
                [(ngModel)]="advisorId"
                [disabled]="disableAdvisor"
                >
                  <mat-option
                    *ngFor="let dataAdvisor of dataAdvisor"
                    (click)="selectAdvisor()"
                    [value]="dataAdvisor.advisorId"
                    >
                    {{dataAdvisor.advisorFullName | translate}}
                  </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field class="card-body-dropdown">
                <mat-label class="filters-label">{{ "TypeOfService" | translate }}*</mat-label>
                <mat-select
                [(ngModel)]="serviceId"
                [disabled]="disableTypeOfServices"
                >
                  <mat-option
                  *ngFor="let dataTypeOfService of dataTypeOfService"
                  (click)="selectTypeOfService()"
                  [value]="dataTypeOfService.serviceId"


                  >
                  {{dataTypeOfService.serviceName | translate}}
                </mat-option>
                </mat-select>
            </mat-form-field>
            <mat-form-field>
                <mat-label class="filters-label">{{ "Brand" | translate }}*</mat-label>
                <mat-select
                #selectBrand
                [disabled]="disableBrands"
                multiple
                (selectionChange)="updateSelectedBrands()"
                >
                  <mat-select-trigger>
                    {{ brandsSelected | translate }}
                  </mat-select-trigger>

                  <div class="select-all">
                    <mat-checkbox
                      class="all-brands-selected"
                      [(ngModel)]="allBrandsSelected"
                      [ngModelOptions]="{ standalone: true }"
                      (change)="toggleAllBrands()"
                      >{{ 'All' | translate }}</mat-checkbox
                    >
                  </div>

                  <mat-option
                  (click)="selectBrands()"
                  *ngFor="let dataBrand of dataBrand"
                  [value]="dataBrand.brandId"

                  >
                  {{dataBrand.brandName | translate}}
                </mat-option>
              </mat-select>
            </mat-form-field>
        </div>
        <div class="row"  [ngClass]="isDisabled ? 'disappear' : undefined">
            <div class="col-lg-2 card-body-calendar-from">
              <mat-form-field class="size-dropdown" hideRequiredMarker="true">
                <mat-label class="filters-label"> {{ "From" | translate }}*</mat-label>
                <input class="from-styles"
                  matInput
                  [matDatepicker]="fromPicker"
                  [(ngModel)]="startDate"
                  (ngModelChange)="ChangeDateEnd()"
                  required
                />
                <mat-datepicker
                  #fromPicker
                >fcvd
                </mat-datepicker>
                <mat-datepicker-toggle
                  matSuffix
                  [for]="fromPicker"
                > <mat-icon matDatepickerToggleIcon>
                  <div>
                    <img
                      src="../../assets/calendar.svg"
                      alt="calendar icon"
                    />
                  </div>
                  </mat-icon>
                </mat-datepicker-toggle>
              </mat-form-field>
            </div>
            <div class="col-lg-2 card-body-calendar-to">
              <mat-form-field class="size-dropdown" hideRequiredMarker="true">
                <mat-label class="filters-label">{{ "To" | translate }}*</mat-label>
                <input
                  matInput
                  [matDatepicker]="toPicker"
                  [(ngModel)]="endDate"
                  [matDatepickerFilter]="dateFilterEnd"
                  required
                />
                <mat-datepicker-toggle
                  matSuffix
                  [for]="toPicker"
                ><mat-icon matDatepickerToggleIcon>
                  <div>
                    <img
                    src="../../assets/calendar.svg"
                    alt="calendar icon"
                    />
                  </div>
                </mat-icon></mat-datepicker-toggle>
                <mat-datepicker
                  #toPicker
                ></mat-datepicker>
              </mat-form-field>
            </div>

            <div class="button-clean-search">
              <button
                class="button-clean"
                (click)="clearFilter()"
              >
                {{"Clean" | translate}}
              </button>

              <button
                class="button-search"
                (click)="searchReport(0)"
                [disabled]="isSearchDisable()"
                [ngClass]="{isDisabled: isSearchDisable(),isEnabled:!isSearchDisable()}"
              >
                {{"Consult" | translate}}
              </button>
            </div>

        </div>
    </div>
    <div class="loading-container" *ngIf="isLoading">
      <section>
        <div  class="pulsing">
          <mat-spinner [diameter]="50" ></mat-spinner>
        </div>
        <p class="pulsing">{{"Searching" | translate}}</p>
      </section>
    </div>
    <ng-container *ngIf="dataShow.length > 0">
      <div class="header-button"  >
      <button class="export-button" (click)="getReport(1)" >
        <i class="material-icons-outlined">download</i><p>{{ "Export" | translate }}</p>
      </button>

      <!-- Grilla -->
      <ng-container *ngIf="isGridVisible">
        <table
          class="table-report scrollable-table"
        >
          <thead class=" desing-head">
              <tr class="row report-headers" >
                  <th class="col tittle1" *ngFor="let test of textHeaders">{{ test | translate}}</th>
                  <th class="col tittle1">Total</th>
              </tr>
          </thead>
          <tbody class="design-body">
              <tr class="row design-body-principal" *ngFor="let post of dataShow; let i = index">
                <td class="col design-body-td" *ngFor="let test of textHeaders; let i = index" [class.firstTd]="i === 0" >{{ (post[test] === 'Schedule' ? 'Scheduled' : (post[test] === 'Cancel' ? 'Canceled' : post[test] )) | translate }}</td>
                <td [ngStyle]="{'background-color': 'var(--brand-primary-color)', 'color': 'white'}" >{{rowTotals[i]}}</td>
              </tr>
          </tbody>

          <tfoot class="foot-report" >
            <tr  class="row design-body-principal" >
              <td class="foot-report-td" *ngFor="let totalFoot of total ">{{totalFoot}}</td>
              <td class="foot-report-td" >{{sumtotalColumn}}</td>
            </tr>
          </tfoot>
        </table>
      </ng-container>

    </div>
    </ng-container>
    <div *ngIf="dataShow.length === 0 && dataSearched ">
      <p class="messageReport"><strong>{{"ThereAreNoRecords" | translate}}</strong></p>
    </div>
  </div>
  <ng-template #incadea>
    <app-i-reports></app-i-reports>
  </ng-template>
</main>
